import { get, post, patch, del } from '../../helpers/api';

const getVehicles = async () => {
  const { data } = await get('/admin/fleet/vehicles');
  return data;
};

const getVehicle = async (vehicleId) => {
  const { data } = await get(`/admin/fleet/vehicles/${vehicleId}`);
  return data;
};

const createVehicle = async (input) => {
  const { data } = await post('/admin/fleet/vehicles', input);
  return data;
};

const updateVehicle = async (vehicleId, input) => {
  const { data } = await patch(`/admin/fleet/vehicles/${vehicleId}`, input);
  return data;
};

const deleteVehicle = async (vehicleId) => {
  await del(`/admin/fleet/vehicles/${vehicleId}`);
};

const getDriverApproval = async (userId) => {
  const { data } = await get(`/admin/fleet/drivers/${userId}/approval`);
  return data;
};

const approveDriver = async ({ userId, assignedBy }) => {
  const { data } = await post('/admin/fleet/drivers/approve', { userId, assignedBy });
  return data;
};

const revokeDriver = async ({ userId }) => {
  const { data } = await post('/admin/fleet/drivers/revoke', { userId });
  return data;
};

const assignVehicleToTrip = async (tripId, fleetVehicleId) => {
  const { data } = await post(`/admin/fleet/trips/${tripId}/assignment`, { fleetVehicleId });
  return data;
};

const attachFleetDriver = async (input) => {
  const { data } = await post('/admin/fleet/trips/attach-driver', input);
  return data;
};

const unassignVehicleFromTrip = async (tripId, fleetVehicleId) => {
  const { data } = await post(`/admin/fleet/trips/${tripId}/unassign`, { fleetVehicleId });
  return data;
};

export default {
  getVehicles,
  getVehicle,
  createVehicle,
  updateVehicle,
  deleteVehicle,
  getDriverApproval,
  approveDriver,
  revokeDriver,
  assignVehicleToTrip,
  attachFleetDriver,
  unassignVehicleFromTrip,
};
